import { useParams } from "react-router-dom";
import { NoneFound } from "../../core/none_found";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";
import { axiosBaseURL } from "../../http";
import { articleBtnStyle, BtnClsNames } from "../../config/btn_config";
import { ArticleContent } from "./components/article_content";
import { BaseContainer } from "../../core/base_container";

export const KnowledgeArticles = () => {
    const { kb_id } = useParams();
    const [articles, setArticles] = useState(null)
    const [show, setShow] = useState()
    const [selectedArticle, setSelectedArticle] = useState()

    useEffect(() => {
        axiosBaseURL.get(`knowledge_api/knowledge_articles/get_kb_articles/?kb=${kb_id}`)
            .then((response) => {
                setArticles(response.data)
                console.log(response.data)
            })
            .catch((error) => {
                console.error(error)
            });
    }, [kb_id]);

    if (kb_id === 'none') {
        return <NoneFound item_name='Articles' min_height={'65vh'} />
    }

    const handleArticleClick = (article) => {
        setSelectedArticle(article)
        setShow(true)
    }

    return (
        <BaseContainer>
            {articles === null ? (
                <Row className="justify-content-center">
                    <Spinner animation="border" role="status" variant="primary"/>
                </Row>
            ) : Array.isArray(articles) && articles.length > 0 ? (
                <>
                    {
                        articles.map((item, index) => (
                            <Row style={{marginBottom:'2rem'}} key={index}>
                                <Col>
                                    <Button
                                        className={BtnClsNames}
                                        style={articleBtnStyle}
                                        onClick={() => handleArticleClick(item)}>
                                        {item.article_name}
                                    </Button>
                                </Col>
                            </Row>
                        ))
                    }
                </>
            ) : (
                <Row className="justify-content-center">
                    <NoneFound item_name='Articles' min_height={'65vh'} />
                </Row>
            )}
            {selectedArticle &&
                <Modal
                    size="lg"
                    show={show}
                    centered
                    scrollable
                    onHide={() => setShow(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Article Content
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ArticleContent article={selectedArticle} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShow(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            }
        </BaseContainer>
    )
}